import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import translateNested from "app/pages/sales-intelligence/common-components/i18n/translateNested";
import SignalTitleWithCountry from "app/pages/sales-intelligence/sub-modules/signals/components/shared/Signal/SignalWithCountry";
import {
    StyledSignalNameText,
    StyledSignalNameWrapper,
} from "app/pages/sales-intelligence/sub-modules/signals/components/shared/Signal/styles";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";
import { isSignalNameWithCountry } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/type-guards/isSignalNameWithCountry";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import SignalNameHtmlWithSelectionTooltips from "app/pages/sales-intelligence/sub-modules/signals/utils/signalNameHtmlWithSelectionTooltips";

import SignalNameWrapperWithTags from "./SignalNameWrapperWithTags";

type Props = {
    uiSignal: Readonly<UISignal<SignalFilters>>;
};

const SignalNameRich = ({ uiSignal }: Props) => {
    const nameContent = (
        <StyledSignalNameWrapper>
            {isSignalNameWithCountry(uiSignal.name) && uiSignal.signalType !== SignalType.Intent ? (
                <SignalTitleWithCountry
                    signalName={uiSignal.name}
                    selectionTooltipLabels={uiSignal.selectionTooltipLabels}
                />
            ) : uiSignal.selectionTooltipLabels ? (
                <StyledSignalNameText data-automation="name-text">
                    <SignalNameHtmlWithSelectionTooltips
                        translatable={uiSignal.name}
                        selectionTooltipLabels={uiSignal.selectionTooltipLabels}
                    />
                </StyledSignalNameText>
            ) : (
                <I18n
                    data-automation="name-text"
                    element={StyledSignalNameText}
                    translatable={uiSignal.name}
                    dangerouslySetInnerHTML={{ __html: translateNested(uiSignal.name) }}
                />
            )}
        </StyledSignalNameWrapper>
    );

    return <SignalNameWrapperWithTags uiSignal={uiSignal}>{nameContent}</SignalNameWrapperWithTags>;
};

export default SignalNameRich;
